import { removeToken } from './subscriptionsService';

let appData = null;
let appDataPromise = null;

const fetchResources = async (token, history) => {
  const res = await fetch(`${process.env.REACT_APP_URL_API}/resources`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  removeToken(res, history);
  const data = await res.json();
  return Array.isArray(data) ? data : [];
};

const fetchSubscriptions = async (token, history) => {
  const res = await fetch(`${process.env.REACT_APP_URL_API}/subscriptions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      xmlTag: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>',
      filtresTag:
        '<filtres xmlns="http://www.atosworldline.com/wsabonnement/v1.0/"></filtres>',
    }),
  });

  removeToken(res, history);
  const data = await res.json();
  return Array.isArray(data?.abonnements) ? data.abonnements : [];
};

export const getAppData = async ({ token, history, force = false }) => {
  if (!force && appData) return appData;
  if (!force && appDataPromise) return appDataPromise;

  const request = Promise.all([
    fetchResources(token, history),
    fetchSubscriptions(token, history),
  ]).then(([resources, subscriptions]) => {
    appData = { resources, subscriptions };
    return appData;
  });

  if (!force) {
    appDataPromise = request.finally(() => {
      appDataPromise = null;
    });
  }

  return request;
};

export const invalidateAppData = () => {
  appData = null;
};

export const addResourceToAppData = (resource) => {
  if (!appData) return;
  appData = {
    ...appData,
    resources: appData.resources.concat(resource),
  };
};

export const updateResourceInAppData = (resourceId, updatedResource) => {
  if (!appData) return;
  appData = {
    ...appData,
    resources: appData.resources.map((resource) =>
      resource._id === resourceId ? { ...resource, ...updatedResource } : resource,
    ),
  };
};

export const removeResourceFromAppData = (resourceId) => {
  if (!appData) return;
  appData = {
    ...appData,
    resources: appData.resources.filter((resource) => resource._id !== resourceId),
  };
};
